import i18n from 'services/base/i18n';

export default {
  title: (family: string, address: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malware Address', 'Blocked %1$s server (%2$s) for %3$s.'),
    family, address, device,
  ),

  description: (family: string, address: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malware Address', 'Traffic to/from a listed %1$s malware server (%2$s) has been blocked by Pangolin from communicating with %3$s'),
    family, address, device,
  ),

  kindTitle:        () => i18n.pgettext('Issues|Malware Address|Kind', 'Malware Address Access'),
  kindSubtitle:     () => i18n.pgettext('Issues|Malware Address|Kind', 'Malware Servers / Spread Vectors'),

  actionValueAllow: () => i18n.pgettext('Issues|Malware Address|Action', 'Allow'),
  actionValueBlock: () => i18n.pgettext('Issues|Malware Address|Action', 'Block'),

  actionLabelAllow: () => i18n.pgettext('Issues|Malware Address|Action', 'Allow traffic between host and address'),
  actionLabelBlock: () => i18n.pgettext('Issues|Malware Address|Action', 'Block traffic between host and address'),
};
